import React, {useContext, useEffect, useState} from "react";
import './EmailActivationView.css';
import RandomSVGPicture from "../../Components/RandomSVGPicture/RandomSVGPicture";
import {Spinner} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import {ArrowLeft} from "react-bootstrap-icons";
import {Context} from "../../ContextProvider/Context";
import {Api} from "../../RequestsProvider/RequestProvider";

export const EmailActivationView = () => {
    const [processing, setProcessing] = useState<boolean>(true);
    const [message, setMessage] = useState<string>('');
    const context = useContext(Context)
    const request = useContext(Api)
    const navigate = useNavigate()

    const {verificationCode} = useParams()
    useEffect(() => {
        if(verificationCode){
            setMessage("verifiziere Email ...")
            activateEmail(verificationCode).then(msg=>{
                setTimeout(() => {
                    setProcessing(false)
                    setMessage(msg.message)
                    setContentLoading(false)
                }, 1200)
            })
        }
    }, []);


    if (!context || !request) {
        return (<></>)
    }
    const {setContentLoading} = context
    const {activateEmail} = request


    return (
        <div>
            <div className="bg-black px-2 py-1">
                <div className="row m-1">
                    <div className="col-6 text-wa_green">
                        <div className="row fs-22">WhatsAppBot</div>
                        <div className="row fs-12 font-regular">mache deine Chats einzigartig!</div>
                    </div>
                </div>
            </div>
            <div>
                <div className="head-navigation py-2 p-0">
                    <div className="col-8">
    <span className={"text-muted font-regular"}><button onClick={() => navigate("/", {replace: true})}
                                                        className={"btn border"}>
    <ArrowLeft className={"pb-1"}/> Startseite
    </button></span>
                    </div>
                </div>
            </div>
            <div>
            </div>
            <div className={"login mt-3 fadeIn"}>
                <h1>
                    <RandomSVGPicture width={100} height={100} rotate={true}/><br/>
                    {processing ? <Spinner size={'sm'}/> : <div className={"fadeIn"}>Vielen Dank</div>}

                </h1>
                <div className="text-center fadeIn">
                    <small>{message}</small><br/>
                </div>
            </div>
        </div>
    )
}
